<app-service-badge *ngIf="fuel" [service]="'fuel'" [text]="fuelText"></app-service-badge>
